import { Link } from 'react-router-dom';
import React from 'react';
import { ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-zinc-100 relative flex items-center justify-center overflow-hidden">
      {/* Subtle grid texture */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
        }}
      />
      <div className="relative z-10 text-center px-8">
        <span className="font-mono text-xs tracking-[0.2em] text-violet-400 uppercase">{'// error'}</span>
        <h1 className="mt-4 text-8xl font-bold text-zinc-100">404</h1>
        <h2 className="mt-2 text-2xl font-semibold text-zinc-200">Page not found</h2>
        <p className="mt-4 text-zinc-400 max-w-md mx-auto leading-relaxed">
          The page you're looking for doesn't exist. It might have been moved, deleted, or the URL is wrong.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center bg-zinc-100 hover:bg-violet-400 text-zinc-900 font-medium px-6 py-3 rounded-md transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
